import { get, post, upload } from '../request'

// 统一上传文件
const uploadFile = {
  upload: (params) =>
    upload('/student-consumer/api/file/uploadFaceImageToOss', params),
  checkImg: (params) => get('tpd-api/api/face/getFaceQuality', params),
}
const wx = {
  // getWXConfig: (params) =>
  //   get('/student-consumer/api/wxBaseApp/getJsapITicket', params),
  getWXConfig: (params) =>
    get('/student-consumer/api/wxBaseApp/getJsapITicketByAppid', params),
  sendNoAuthWxMsg: (params) =>
    get('/student-consumer/api/schoolTemplate/sendNoAuthMessage', params),
}
// 字典
const dictionary = {
  getwork: (params) =>
    get('auth/api/sysDictData/getSysDictDataListByDictType', params),
  getSysSchool: (params) =>
    get('/student-consumer/api/functionParam/getFunctionParamList', params),
}
//保安查看的访客记录
const visitorFk = {
  //访客列表记录
  visitorRecord: (params) => get("student-consumer/api/visitor/getVisitorListService", params),
  //根据id查出访客信息
  visitorDetail: (params) => get("student-consumer/api/visitor/getVisitorDetailsById", params),
};


// 预约
const visitor = {

  // 获取公众号关注状态
  getIsSubscribe: (params) => get('/student-consumer/api/wxBaseApp/isSubscribe', params),
  singleAppointment: (params) =>
    post('/student-consumer/api/visitor/saveVisitorMessage', params),
  getUserDept: (params) =>
    get('/student-consumer/api/audit/getUserDept', params), // 搜索审批人员
  getHistoryDept: (params) =>
    get('/student-consumer/api/userRedis/getUserOptions', params), // 查询历史审批
  getVisitorList: (params) =>
    get('/student-consumer/api/visitor/getVisitorList', params),
  getVisitorDetail: (params) =>
    get('/student-consumer/api/visitor/getAuditVisitorDetails', params), //原来是这个getAuditVisitorDetails
  editVisitor: (params) =>
    post('/student-consumer/api/visitor/updateVisitorPersonnel', params),
  getMaxDuration: (params) =>
    get('/student-consumer/api/visitor/getSchoolMessage', params),
  getPersonList: (params) =>
    get('/student-consumer/api/visitor/getAuditStaffVisitorDetails', params),
  setPerson: (params) =>
    post('/student-consumer/api/visitor/singleSaveVisitorMessage', params),
  delPerson: (params) =>
    post('/student-consumer/api/visitor/singleDeleteVisitorMessage', params),
  getNoTokenDetail: (params) =>
    get('/student-consumer/api/visitor/getAuditVisitorDetailsNotice', params),
  getNoTokenPersonDetail: (params) =>
    get(
      '/student-consumer/api/visitor/getAuditStaffVisitorDetailsNotice',
      params
    ),
  transienceSave: (params) =>
    post('/student-consumer/get/qrcode/save/HoldVisitorMessage', params), // 暂存获取二维码
  subTransienceSave: (params) =>
    post('/student-consumer/get/qrcode/submit/HoldVisitorMessage', params), // 暂存提交
  undoVisitor: (params) =>
    post('/student-consumer/api/visitor/withdrawVisitorMessage', params), // 待审批撤回
}

// 审批
const audit = {
  getAuditList: (params) =>
    get('/student-consumer/api/visitor/getAuditVisitorList', params),
  audit: (params) => post('/student-consumer/api/audit/updateAudit', params),
  getUserDeptListAll: (params) =>
    get('/student-consumer/api/audit/getUserDeptList', params),
  getAuditStatus: (params) =>
    get('/student-consumer/api/audit/getAuditStatus', params),
}
// 多学校
const school = {
  getSchoolList: (params) =>
    // get('/student-consumer/api/UserSchool/getUser', params),
    get('/student-consumer/api/user/getSchoolTpdUser', params),
  updateSchool: (params) => post('auth/api/switchAccount', params),
  identitySwitch: (params) => post('auth/api/identitySwitch', params),
  bindPhone: (params) =>
    post('/student-consumer/api/UserSchool/bangDingUser', params),
}

// 考勤
const attendance = {
  getAbsentWorkBySchoolId: (params) =>
    get('/student-consumer/api/leave/getAbsentWorkBySchoolId', params),//查询缺勤榜
  getFullAttendanceBySchoolId: (params) =>
    get('/student-consumer/api/leave/getFullAttendanceBySchoolId', params),//查询全勤榜
  getAttendanceCountByStudentId: (params) =>
    get('/student-consumer/api/leave/getAttendanceCountByStudentId', params),//查询月考勤汇总
  statistics: (params) =>
    get('/student-consumer/api/leave/getSigninHistory', params),
  getMyLeaveList: (params) =>
    get('/student-consumer/api/attendance/getVacateList', params),
  getApproveLeaveList: (params) =>
    get('/student-consumer/api/attendance/getVacate/approvalList', params),
  initiateMyLeave: (params) =>
    post('/student-consumer/api/attendance/vacate/apply', params),
  approveLeave: (params) =>
    post('/student-consumer/api/attendance/vacate/approval', params),
  getCalendar: (params) =>
    get('/student-consumer/api/leave/getCalendar', params),
  getAllChild: (params) =>
    get('/student-consumer/api/attendance/getFamilyMember', params), // 查询家长下的孩子
  getClassesAttendance: (params) =>
    get('/student-consumer/api/leave/getPersonNumber', params), // 获取班级的统计
  getLastLeaveDetail: (params) =>
    get('/student-consumer/api/attendance/getLastVacateAudit', params),
  getClassListByTeacherId: (params) =>
    get('/student-consumer/api/class/getClassListByTeacherId', params),
  getStudentDataByClassIdAndDate: (params) =>
    post('/student-consumer/api/leave/getStudentDataByClassIdAndDate', params),
  getVacateById: (params) =>
    get('/student-consumer/api/attendance/getVacateById', params),

  leaveOfffor: (params) =>
    post('/student-consumer/api/attendance/vacate/destroy', params),
  leaveOffListAudit: (params) =>
    get('/student-consumer/api/attendance/getVacate/destroyrovalList', params),
  leaveOffAudit: (params) =>
    post('/student-consumer/api/attendance/vacate/destroyroval', params),
  getClassInfo: (params) =>
    get('/student-consumer/api/class/getClassStaticsDataByschoolIdAndDate', params),
  getLeaveStudentDataByschoolId: (params) => get('/student-consumer/api/leave/getLeaveStudentDataByschoolId', params),

  getTeacherDataByschoolId: (params) => get('/student-consumer/api/leave/getTeacherDataByschoolId', params),
  getDeptStaticsDataByschoolIdAndDate: params => get('/student-consumer/api/dept/getDeptStaticsDataByschoolIdAndDate', params),
  getDeptStaticsDataByschoolId: (params) => get('/student-consumer/api/dept/getDeptStaticsDataByschoolId', params),
  getStudentDataByDeptIdAndDate: (params) => get('/student-consumer/api/leave/getStudentDataByDeptIdAndDate', params),
  getDeptSigninHistory: (params) => get('/student-consumer/api/leave/getDeptSigninHistory', params),
  getMonthCalendar: (params) => get('/student-consumer/api/leave/getMonthCalendar', params),//老师月出勤日历
  getMonthCalendarData: (params) => get('/student-consumer/api/leave/getMonthCalendarData', params),//老师月出勤数据汇总
  getStudentMonthCalendar: (params) => get('/student-consumer/api/leave/getStudentMonthCalendar', params),//学生月出勤日历
  getStudentMonthCalendarData: (params) => get('/student-consumer/api/leave/getStudentMonthCalendarData', params),//学生月出勤数据汇总
  getHolidaysDay: (params) => get('/student-consumer/api/leave/getHolidaysDay', params),//节假日


  // 成绩查询

  // 获取未到学生清单
  getStudentList: (params) => get('student-consumer/api/leave/getMissStudentList', params),
  // 晚归/未归
  getDormNotIn: (params) => get('student-consumer/api/dormAddSignature/getDormNotIn', params),


  dormSignInPlatform: (params) => post('student-consumer/nonInductive/attendance/dormSignInPlatform', params),
  findSignStatus: (params) => post('student-consumer/api/dormInoutTime/findSignStatus', params),
  // 获取验证码
  getCaptchaImage: (params) => get('/student-consumer/api/examResults/getCaptchaImage', params),//节假日

  // 查询考生成绩
  getPersonResults: (params) => post('/student-consumer/api/examResults/getPersonResults', params),

  // 成绩查询名称
  getScoreName: (params) => get('/student-consumer/api/examResults/getExamResultsTitle', params),
  // 宿舍补签
  dormWarningStatusUpdatePlatform: (params) => post('student-consumer/nonInductive/attendance/dormWarningStatusUpdatePlatform',params),
  
  //请假未到校补签
  leaveNotInSchoolSignInPlatform: (params) => post('student-consumer/nonInductive/attendance/leaveNotInSchoolSignInPlatform',params)

}

// 代接送
const pickUp = {
  savePickUp: (params) => post('/student-consumer/pickup/save/pickUp', params), // 发起代接送审批
  pickupList: (params) => get('/student-consumer/pickup/get/pickUpList', params),
  pickupDetail: (params) =>
    get('/student-consumer/pickup/get/pickUpdetails', params),
  pickupAudit: (params) =>
    post('/student-consumer/pickup/update/auditState', params),
  pickupAuditList: (params) =>
    get('/student-consumer/pickup/get/pickUpAuditList', params),
  // getChildClasses: (params) =>
  //   get('/student-consumer/api/class/getClassListByTeacherId', params), // 获取班级
  getPickUpLastDetail: (params) =>
    get('/student-consumer/pickup/getPickUpLastDetail', params),
  getChildID: (params) =>
    get('/student-consumer/api/user/getUserInfoById', params),
}


// 进出
const access = {
  saveAccess: (params) =>
    post('/student-consumer/api/temporary/addTemporary', params),
  getAccessList: (params) =>
    get('/student-consumer/api/temporary/getTemporary', params),
  accessAudit: (params) =>
    post('/student-consumer/api/temporary/updateTemporary', params),
  getDormitoryStatisticsError: (params) =>
    get('student-consumer/api/dormitoryStatistics/getDormitoryStatisticsError', params)

}

// 会员
const vip = {
  saveEditData: (params) =>
    post('/student-consumer/api/parentsPay/updateSubscriber', params), // 修改订阅人员
  getByChildrenIdOne: (params) =>
    get('/student-consumer/api/order/getByChildrenIdOne', params), // 根据孩子id和用户id获取绑定人员详情
  getParentsList: (params) =>
    get('/student-consumer/api/user/getParentsList', params), // 获取绑定人员列表
  //get('/student-consumer/api/parentsPay/getParentsList', params), // 获取绑定人员列表
  addParent: (params) =>
    post('/student-consumer/api/parentsPay/saveParentsPayBanding', params), // 添加绑定人员列表
  delParent: (params) =>
    post('/student-consumer/api/parentsPay/deleteParentsPayBanding', params), // 删除绑定人员列表
  createOrder: (params) =>
    post('/student-consumer/api/order/creatOrder', params), // 生成订单
  getVipList: (params) =>
    get('/student-consumer/api/order/getProductList', params), //获取会员列表
  getUserInfoById: (params) =>
    get('/student-consumer/api/user/getUserInfoById', params), //根据userId查询家长信息
  getPackageList: (params) =>
    get('/student-consumer/api/order/getPackageList', params), // 获取套餐列表
  getSubPersonList: (params) =>
    get('/student-consumer/api/parentsPay/getParentsPayBandingList', params), // 获取订单人员列表
  getSubNotPersonList: (params) =>
    get('/student-consumer/api/parentsPay/getParentsPayNotBandingList', params), // 获取未绑定订单人员列表
  createPayOrder: (params) =>
    post('/student-consumer/api/pay/createPayOrder', params), // 微信统一下单接口
  getPayOrder: (params) => get('/student-consumer/api/pay/queryOrder', params), // 查询订单支付结果信息
  getOrderDetail: (params) =>
    get('/student-consumer/api/order/getOrderDetail', params), // 获取订单详情
  getMyOrder: (params) =>
    get('/student-consumer/api/order/getOrderListByUser', params),
  //get('/student-consumer/api/order/getOrderList', params), // 查询我的订单
  getUserBindPerson: (params) =>
    post('/student-consumer/api/parentsPay/getParentsPayAuthList', params), // 查询根据条件查询人员授权列表信息
  cancelOrder: (params) =>
    post('/student-consumer/api/order/cancelOrder', params),//取消订单
  getStudentByPhone: (params) =>
    get('/student-consumer/api/user/getStudentByPhone', params),
  getParentsPayAuthChildrenList: (params) =>
    get(
      '/student-consumer/api/parentsPay/getParentsPayAuthChildrenList',
      params
    ),
  editBindPerson: (params) =>
    post('/student-consumer/api/parentsPay/updateParentsPayBanding', params), // 修改绑定人员
}

//临时信息录入
const personnel = {
  getPendingUserTemporary: (params) =>
    get('/student-consumer/api/userTemporary/getPendingUserTemporary', params), // 根据个人信息获取待审批人员列表
  batchApproval: (params) =>
    post('/student-consumer/api/userTemporary/batchApproval', params), // 批量审批信息
}



// 活动室预约相关接口
const activityroom = {
  // 根据条件查询可预约的活动室列表
  getActivityRoomOptions: (params) => get('/student-consumer/api/activity/room/getActivityRoomOptions', params),
  // 预约申请
  appointmentApplication: (params) => post('/student-consumer/api/activity/app/appointmentApplication', params),
  // 取消预约
  cancel: (params) => post('/student-consumer/api/activity/app/cancelAppointment', params),
  // 根据活动室预约ID获取可预约日期列表
  getActivityRoomAppDateList: (params) => get('/student-consumer/api/activity/app/getActivityRoomAppDateList', params),
  // 根据活动室预约ID和时间获取可预约时段列表
  getActivityRoomAppTimeSlotList: (params) => get('/student-consumer/api/activity/time/getActivityRoomAppTimeSlotList', params),
  // 获取我的申请记录
  getApplicationRecord: (params) => post('/student-consumer/api/activity/app/getApplicationRecord', params),
  // 获取预约记录详情
  getApplicationDetails: (params) => get('/student-consumer/api/activity/app/getApplicationDetails', params),
  // 获取活动室分类
  getRoomType: (params) => get('student-consumer/api/activity/room/getRoomType', params),

  // 查看使用中的活动室信息
  getRoomUseDetail: (params) => get('student-consumer/api/activity/app/statisticsByUse', params),

  // cas认证平台登录接口
  casLogin: (params) => get('auth/cas/login', params),

  // 搜索团体成员
  searchTeamList: (params) => post('/student-consumer/api/user/getStudentByParam', params),
  // 搜索团体成员 （ 老师和学生 ）
  searchTeamListStudentOrTeacher: (params) => post('/student-consumer/api/user/getPersonByParam', params),


  // 活动室预约记录查询
  getApplicationRecord: (params) => post('student-consumer/api/activity/app/getApplicationRecord', params),
  // 预约审批
  appointmentApproval: (params) => post('student-consumer/api/activity/audit/appointmentApproval', params),

  // 获取活动室详情
  getRoomById: (params) => get('student-consumer/api/activity/room/getById', params),
  // 老师查询待审批数据
  getTeacherApprover: (params) => post('student-consumer/api/activity/audit/teacherApprover', params),
  // 家长权限
  getParentMenuList: (params) => get('auth/api/parentMenu/getParentRouter',params),
  // 老师权限
  getTeachMenuList: (params) => get('auth/api/teachMenu/getRouter',params),

}

export default {
  ...visitor,
  ...uploadFile,
  ...audit,
  ...dictionary,
  ...wx,
  ...school,
  ...attendance,
  ...pickUp,
  ...access,
  ...vip,
  ...personnel,
  ...visitorFk,
  ...activityroom
}
